import React from "react";
import { useOutletContext } from "react-router-dom";
import AccountListPage from "../features/userManagement/AccountListPage";

const Merchants = () => {
  const context = useOutletContext() || {};
  return <AccountListPage type="merchants" language={context.language} direction={context.direction} />;
};

export default Merchants;
